<template>
  <MenuList
    class="app-left"
    :collapsed="collapsed"
    :menu-data="subMenuList"
    :collapsible="true"
    :isMobile="false"
  />
</template>

<script>
import MenuList from './components/Menu/SiderMenu'
export default {
  name: 'AppLeft',
  components: {
    MenuList
  },
  data () {
    return {}
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    subMenuList: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
  .app-left {
  }
</style>
